<template>
  <BaseCard noPadding class="tw:my-4 tw:p-4" dataTestId="premium-products-overview-component">
    <div v-if="isInitialLoading">
      <div class="tw:animate-pulse tw:bg-gray-300 tw:rounded tw:w-full tw:h-80" aria-hidden="true" />
    </div>
    <div v-else-if="isError" class="tw:text-red-700" v-html="$t('errors.wrong_data_from_app')" />
    <div v-else-if="!isInitialLoading">
      <PremiumProductsContainer />
    </div>
  </BaseCard>
</template>

<script setup lang="ts">
import { computed, type ComputedRef } from 'vue'
import { useStore } from 'vuex'

import BaseCard from '@/components/dashboard/BaseCard.vue'
import PremiumProductsContainer from '@/components/billing/premiumProducts/PremiumProductsContainer.vue'

import { useAccommodationsByOrgId } from '@/layouts/queries'

const store = useStore()

/** Currently selected organisation ID from session */
const selectedOrganisationId: ComputedRef<string | undefined> = computed(
  () => store.state?.session?.selectedOrganisation?.id
)

const { isAccommodationsByOrgIdInitialLoading, isAccommodationsByOrgIdError } =
  useAccommodationsByOrgId(selectedOrganisationId)

/** Loading state for accommodations data */
const isInitialLoading: ComputedRef<boolean> = computed(() => isAccommodationsByOrgIdInitialLoading.value)

/** Error state for accommodations data */
const isError: ComputedRef<boolean> = computed(() => isAccommodationsByOrgIdError.value)
</script>
